module.exports = __webpack_public_path__ + "static/media/VV 24.1020f3a3.mp3";